/**
 * MUSKLE Points overview — live balance/history (Concept 02).
 * Display mapping only. Does not change Points ledger logic.
 *
 * Root-cause fix: gate may dispatch logged-in BEFORE this deferred script
 * registers its listener (Liquid customer hint path). Always catch-up if
 * member content is already visible.
 */
(function () {
  'use strict';

  function decodeConfig(raw) {
    if (!raw) return null;
    var text = String(raw);
    if (text.indexOf('&') >= 0) {
      var ta = document.createElement('textarea');
      ta.innerHTML = text;
      text = ta.value;
    }
    try {
      return JSON.parse(text);
    } catch (e) {
      return null;
    }
  }

  function isContentVisible(el) {
    if (!el) return false;
    if (el.hasAttribute('hidden')) return false;
    var display = '';
    try {
      display = window.getComputedStyle(el).display;
    } catch (e) {
      display = el.style.display || '';
    }
    return display !== 'none';
  }

  function bootRoot(root) {
    if (!root || root.getAttribute('data-mpd-booted') === '1') return;
    var cfg = decodeConfig(root.getAttribute('data-mpd-config'));
    if (!cfg || !cfg.sectionId) return;
    root.setAttribute('data-mpd-booted', '1');

    var fallbackEl = document.getElementById('MusklePointsFallback-' + cfg.sectionId);
    var memberContent = document.getElementById(cfg.memberContentId);
    if (!memberContent) return;
    var placeholders = memberContent.querySelector('[data-mpd-placeholders]');
    var started = false;

    function showFallback(message) {
      var loading = root.querySelector('[data-mpd-loading]');
      if (loading) loading.hidden = true;
      var how = root.querySelector('[data-mpd-how]');
      if (how) how.hidden = true;
      var balanceCard = root.querySelector('[data-mpd-balance-card]');
      if (balanceCard) balanceCard.hidden = true;
      var historySection = root.querySelector('[data-mpd-history-section]');
      if (historySection) historySection.hidden = true;
      if (fallbackEl) {
        fallbackEl.hidden = false;
        var note = fallbackEl.querySelector('.mpd-c02-foundation');
        if (note && message) note.textContent = message;
      }
    }

    function showLiveShell() {
      if (fallbackEl) fallbackEl.hidden = true;
      root.hidden = false;
      var how = root.querySelector('[data-mpd-how]');
      if (how) how.hidden = false;
    }

    function formatInt(n) {
      var num = Number(n);
      if (!Number.isFinite(num)) return '';
      try {
        return new Intl.NumberFormat(cfg.locale === 'en' ? 'en-GB' : 'nl-NL').format(Math.round(num));
      } catch (e) {
        return String(Math.round(num));
      }
    }

    function formatDate(iso) {
      if (!iso) return '';
      try {
        return new Date(iso).toLocaleDateString(cfg.locale === 'en' ? 'en-GB' : 'nl-NL', {
          day: 'numeric',
          month: 'short',
          year: 'numeric',
        });
      } catch (e) {
        return '';
      }
    }

    function orderRef(row) {
      var name = row && row.order_name != null ? String(row.order_name).trim() : '';
      return name || '';
    }

    function historyLabel(row) {
      var reason = String((row && row.reason) || '').toLowerCase();
      var ref = orderRef(row);
      var L = cfg.labels || {};

      if (reason === 'refund_clawback') return L.refundAdjust || L.pointsActivity;
      if (reason === 'pwa_install_bonus') return L.pwaBonus || L.pointsActivity;
      if (
        reason === 'points_shop_redeem' ||
        reason === 'points_shop_order_redeem' ||
        reason === 'points_shop_partial_redeem'
      ) {
        return L.shopRedeem || L.pointsActivity;
      }
      if (reason === 'order_paid_earn') {
        return ref ? (L.orderActivity || L.pointsEarned) + ' · ' + ref : L.pointsEarned || L.pointsActivity;
      }
      if (reason === 'action_claim_earn') return L.pointsEarned || L.pointsActivity;
      if (reason.indexOf('order') >= 0) {
        return ref ? (L.orderActivity || L.pointsActivity) + ' · ' + ref : L.orderActivity || L.pointsActivity;
      }
      if (reason.indexOf('refund') >= 0 || reason.indexOf('clawback') >= 0) {
        return L.refundAdjust || L.pointsActivity;
      }
      if (reason.indexOf('redeem') >= 0 || reason.indexOf('shop') >= 0) {
        return L.shopRedeem || L.pointsActivity;
      }
      if (reason.indexOf('pwa') >= 0 || reason.indexOf('install') >= 0) {
        return L.pwaBonus || L.pointsActivity;
      }
      return L.pointsActivity || 'Points';
    }

    function renderLive(data) {
      showLiveShell();
      var loading = root.querySelector('[data-mpd-loading]');
      var balanceCard = root.querySelector('[data-mpd-balance-card]');
      var balanceEl = root.querySelector('[data-mpd-balance]');
      var lifetimeEl = root.querySelector('[data-mpd-lifetime]');
      var historySection = root.querySelector('[data-mpd-history-section]');
      var historyList = root.querySelector('[data-mpd-history-list]');
      var historyEmpty = root.querySelector('[data-mpd-history-empty]');
      var policyEl = root.querySelector('[data-mpd-policy]');

      if (loading) loading.hidden = true;
      if (balanceCard) balanceCard.hidden = false;

      var balance = typeof data.balance === 'number' ? data.balance : 0;
      if (balanceEl) balanceEl.textContent = formatInt(balance);

      if (lifetimeEl && typeof data.lifetime_earned === 'number' && data.lifetime_earned >= 0) {
        lifetimeEl.textContent = (cfg.labels.lifetimePrefix || '') + ' ' + formatInt(data.lifetime_earned);
        lifetimeEl.hidden = false;
      } else if (lifetimeEl) {
        lifetimeEl.hidden = true;
      }

      var history = Array.isArray(data.history) ? data.history : [];
      if (historySection) historySection.hidden = false;
      if (historyList) {
        historyList.innerHTML = '';
        history.forEach(function (row) {
          var deltaNum = Number(row.delta);
          var li = document.createElement('li');
          li.className = 'mpd-c02-activity__item';

          var icon = document.createElement('div');
          icon.className = 'mpd-c02-activity__icon';
          icon.setAttribute('aria-hidden', 'true');
          icon.innerHTML =
            '<svg viewBox="0 0 24 24" width="18" height="18" fill="none"><path d="M12 3 14.5 9.5 21 12l-6.5 2.5L12 21l-2.5-6.5L3 12l6.5-2.5L12 3Z" stroke="currentColor" stroke-width="1.7" stroke-linejoin="round"/></svg>';

          var body = document.createElement('div');
          body.className = 'mpd-c02-activity__body';
          var title = document.createElement('p');
          title.className = 'mpd-c02-activity__title';
          title.textContent = historyLabel(row);
          var meta = document.createElement('p');
          meta.className = 'mpd-c02-activity__meta';
          meta.textContent = formatDate(row.created_at);
          body.appendChild(title);
          body.appendChild(meta);

          var pts = document.createElement('span');
          pts.className = 'mpd-c02-activity__delta';
          if (Number.isFinite(deltaNum) && deltaNum !== 0) {
            pts.textContent = (deltaNum > 0 ? '+' : '') + formatInt(deltaNum);
            pts.classList.add(deltaNum > 0 ? 'is-pos' : 'is-neg');
          } else {
            pts.textContent = '0';
          }

          li.appendChild(icon);
          li.appendChild(body);
          li.appendChild(pts);
          historyList.appendChild(li);
        });
      }
      if (historyEmpty) historyEmpty.hidden = history.length > 0;

      if (policyEl && data.policy) {
        var parts = [];
        if (data.policy.public_cash_value === false && cfg.labels.policyNoCash) {
          parts.push(cfg.labels.policyNoCash);
        }
        if (data.policy.points_expire === false && cfg.labels.policyNoExpiry) {
          parts.push(cfg.labels.policyNoExpiry);
        }
        policyEl.textContent = parts.join(' ');
        policyEl.hidden = parts.length === 0;
      }

      if (cfg.hideBlocksWhenLive && placeholders) placeholders.hidden = true;
    }

    function loadProxy() {
      if (started) return;
      started = true;
      if (!cfg.enableProxy) {
        showFallback(cfg.labels.fallbackDefault);
        return;
      }
      showLiveShell();
      var loading = root.querySelector('[data-mpd-loading]');
      if (loading) loading.hidden = false;

      fetch(cfg.proxyPath, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (res) {
          return res
            .json()
            .then(function (body) {
              return { ok: res.ok, body: body };
            })
            .catch(function () {
              return { ok: false, body: null };
            });
        })
        .then(function (result) {
          var body = result.body || {};
          if (result.ok && body.foundation !== true && typeof body.balance === 'number') {
            renderLive(body);
            return;
          }
          showFallback(cfg.labels.fallbackDefault);
        })
        .catch(function () {
          showFallback(cfg.labels.fallbackDefault);
        });
    }

    function onLoggedIn() {
      if (cfg.editorBypass) {
        showFallback(cfg.labels.fallbackDefault);
        return;
      }
      loadProxy();
    }

    if (cfg.editorBypass) {
      onLoggedIn();
      return;
    }

    if (cfg.gateEvent) {
      document.addEventListener(cfg.gateEvent, onLoggedIn);
    }

    // Catch-up: Liquid hint path can dispatch before this deferred script boots.
    if (isContentVisible(memberContent)) {
      onLoggedIn();
    } else if (!cfg.gateEvent) {
      onLoggedIn();
    } else {
      // Poll briefly in case gate resolves after script init without a replayed event.
      var tries = 0;
      var timer = setInterval(function () {
        tries += 1;
        if (isContentVisible(memberContent)) {
          clearInterval(timer);
          onLoggedIn();
        } else if (tries >= 40) {
          clearInterval(timer);
        }
      }, 100);
    }
  }

  function init() {
    document.querySelectorAll('[data-mpd-live-root][data-mpd-config]').forEach(bootRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
